<header class="site-header">
    <a href="https://www.hep.hr/" target="_blank" class="logo-link">
        <img src="assets/img/bijeliHepLogo.svg" alt="HEP logo" class="logo">
    </a>

<nav class="nav-links" *ngIf="postsService.natjecaj">
    <a *ngIf="postsService.natjecaj.natjecajDocLink"
       [href]="postsService.natjecaj.natjecajDocLink"
       class="mob"
       target="_blank">
       o natječaju
    </a>

    <span *ngIf="postsService.natjecaj.natjecajDocLink
              && postsService.natjecaj.natjecajUputeLink"
          style="color: #c62828;">|</span>

    <a *ngIf="postsService.natjecaj.natjecajUputeLink"
       [href]="postsService.natjecaj.natjecajUputeLink"
       class="mob"
       target="_blank">
       upute
    </a>
   <span *ngIf="postsService.natjecaj.natjecajUputeLink
              && postsService.natjecaj.natjecajFaqLink"
          style="color: #c62828;">|</span>
    <a *ngIf="postsService.natjecaj.natjecajFaqLink"
       [href]="postsService.natjecaj.natjecajFaqLink"
       class="mob"
       target="_blank">
       pitanja
    </a>
</nav>

</header>



<section class="email-container" style="margin-top:27%; background-color:white;">
    <div style="color: #575756  ; ">
          <div  class="tekst">
            <div style="white-space: pre-wrap;">{{postsService.natjecaj.natjecajNeaktivanTekst}}</div>

           
        </div>

    </div>
</section>

<footer>
    <p>Hrvatska elektroprivreda d.d. <span style="color: #c62828;">|</span> Ulica grada Vukovara 37
        <span style="color: #c62828;">|</span> 10 000 Zagreb</p>
</footer>
